export const ADD_SUBCART = "ADD_SUBCART";
export const ADD_TYPE = "ADD_TYPE";
export const ADD_TOTAL = "ADD_TOTAL";
export const UPDATE_SUB_CART = "UPDATE_CART";
export const PLUS_PRODUCT = "PLUS_PRODUCT";
export const MINUS_PRODUCT = "MINUS_PRODUCT";
export const ADD_BRANCH = "ADD_BRANCH";
